import api from "./api";
import {
  ApiResponse,
  CommonParams,
  ESTATUS_LEARNING,
  LessonDetailDto,
  LessonUnitDto,
  UnitsDto,
} from "@/types";
async function getLessonDetail(id: number): Promise<LessonDetailDto | null> {
  try {
    const response = await api.get<ApiResponse<LessonDetailDto>>(
      "/lesson/" + id
    );
    return response.data?.data;
  } catch (error: any) {
    throw error?.response?.data;
  }
}
async function getUnits() {
  try {
    const response = await api.get<
      ApiResponse<{ id: number; title: string }[]>
    >(`/lesson/units/simple`);
    return response.data.data;
  } catch (error: any) {
    return [];
  }
}

async function getLessonUnits(
  query?: any
): Promise<ApiResponse<LessonUnitDto[]>> {
  try {
    const response = await api.get(`/lesson/units`, { params: query });
    return response.data;
  } catch (error: any) {
    return {
      data: [],
      status: error.response?.data?.status || 500,
      message: error.response?.data?.message,
      pagination: {
        hasNextPage: false,
        hasPreviousPage: false,
        itemCount: 0,
        page: 1,
        pageCount: 0,
        pageSize: 12,
      },
    };
  }
}

async function getLessonUnitDetail(
  id: number,
  query: CommonParams<{}>
): Promise<ApiResponse<UnitsDto | null>> {
  try {
    const response = await api.get(
      `/lesson/units/` + id,
      { params: query }
    );
    return response.data;
  } catch (error: any) {
    return {
      data: { data: [], unit: null as any },
      status: error.response?.data?.status || 500,
      message: error.response?.data?.message,
      pagination: {
        hasNextPage: false,
        hasPreviousPage: false,
        itemCount: 0,
        page: 1,
        pageCount: 0,
        pageSize: 15,
      },
    };
  }
}

async function updateLessonCompleted(id: number){
  try {
    const resp = await api.patch(
      `/lesson/${id}/completed`,
      { status: ESTATUS_LEARNING.COMPLETED }
    );
    return resp.data;
  } catch (error: any) {
    return error?.data?.message;
  }
}

export {
  getLessonDetail,
  getUnits,
  getLessonUnits,
  getLessonUnitDetail,
  updateLessonCompleted,
};
